import React, { useState } from 'react';
import useUI from 'src/hooks/use-ui';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useEnterpriseMobileAppSettingsQuery } from 'types/graphql';
import useStores from 'shared/hooks/use-stores';
import Meta from './meta';

export default function SmartBanner(): JSX.Element | null {
  const { embeddedEventDispatcher } = useUI();
  const { dispensary } = useDispensary();
  const [dispatchedToEmbedded, setDispatchedToEmbedded] = useState(false);
  const { apolloClient } = useStores();

  const { showMobileAppSmartBanner } = dispensary.storeSettings;
  const enterpriseId = dispensary.retailer?.enterpriseId;

  const { data } = useEnterpriseMobileAppSettingsQuery({
    client: apolloClient,
    variables: { enterpriseId },
    skip: !enterpriseId || !showMobileAppSmartBanner,
  });

  const appStoreId = data?.enterpriseMobileAppSettings?.iosAppStoreId;

  if (!appStoreId || !showMobileAppSmartBanner) {
    return null;
  }

  if (!dispatchedToEmbedded) {
    embeddedEventDispatcher('mobileApp:addSmartBannerMetaTags', {
      appStoreId,
    });
    setDispatchedToEmbedded(true);
  }

  return <Meta property='apple-itunes-app' content={`app-id=${appStoreId}`} />;
}
